module.exports = __webpack_public_path__ + "static/grace-a8ff5b08d04506e050f10e9cf9fcfc2d.png";